import React from "react";
import service from "../../pages/test-form/data";
import Form, {
  Label,
  ButtonItem,
  Tab,
  TabbedItem,
  TabPanelOptions,
  ColCountByScreen,
  GroupItem,
  SimpleItem,
} from "devextreme-react/form";
import TabPanel from "devextreme-react/tab-panel";
import Toolbar, { Item } from "devextreme-react/toolbar";
import LoadIndicator from "devextreme-react/load-indicator";
import notify from "devextreme/ui/notify";
import { Button } from "devextreme-react/button";
// import "../../pages/test-form/cssPage.css";
import "../client-login/client-login.css";
import { Footer } from "../../components";
import appInfo from "../../../src/app-info";

const { REACT_APP_SERVER_URL } = process.env;

class App extends React.Component {
  constructor(props) {
    super(props);

    this.doc = service.getEmployee();
    this.formElement = React.createRef();

    this.state = {
      isNextTabVisible: true,
      selectedTabIndex: 0,
      isFirsTimeLoaded: false,
      isFormSubmited: false,
      phoneMask: "\\972000000000",
      logoUrl: "",
    };

    this.fetchTemplate = this.fetchTemplate.bind(this);
    this.visibleFunction = this.visibleFunction.bind(this);
    this.execFunction = this.execFunction.bind(this);
    this.getField = this.getField.bind(this);
    this.getTabs = this.getTabs.bind(this);
    this.HideNextTab = this.HideNextTab.bind(this);
    this.NextTab = this.NextTab.bind(this);
    this.PrevTab = this.PrevTab.bind(this);
    this.PostFormToDB = this.PostFormToDB.bind(this);
    this.sendForm = this.sendForm.bind(this);
    this.updatePhones = this.updatePhones.bind(this);
  }
  render() {
    this.fetchTemplate();
    const submitButtonOptions = {
      text: "שלח",
      icon: "exportselected",
      validationGroup: "ownerGroup",
      elementAttr: {
        class: "sendButton",
      },
      useSubmitBehavior: true,
      onClick: (e) => {
        this.sendForm(e);
      },
    };
    const onTabSelectionChanged = (e) => {
      this.setState({
        selectedTabIndex: [
          "בירור צרכים",
          "בעלי חשבון",
          "מדיניות השקעה",
          "חשבונות",
          "מידע נוסף",
          "נספחים",
        ].indexOf(e.addedItems[0].title),
      });
      this.HideNextTab();
    };
    if (this.state.isFormSubmited) {
      return (
        <React.Fragment>
          <div className="form-container">
            <div className="logoImage">
              <img src={this.state.logoUrl} alt="Logo"></img>
            </div>
            <div className="contentAfterSend">
              <h2>הטופס נשלח בהצלחה</h2>
              <h3> הפרטים שמולאו נשלחו במייל לבעל הרשיון</h3>
              {/* <h4>ניצור איתך קשר להמשך התהליך</h4> */}

              <Footer>
                Copyright © 2010-{new Date().getFullYear()}{" "}
                {appInfo.companyEnglishName}.{/* <br /> */}
                כל הזכויות שמורות.
              </Footer>
            </div>
          </div>
        </React.Fragment>
      );
    } else if (this.state.isFirsTimeLoaded) {
      return (
        <React.Fragment>
          <div className="form-container">
            <div className="logoImage">
              <img src={this.state.logoUrl} alt="Logo"></img>
            </div>
            <h3 className="headline">ברוך הבא למערכת הסכמים חכמים</h3>
            <Toolbar
              height={"50px"}
              width={"100%"}
              className={"class='toolbar'"}
              elementAttr={{ id: "top" }}
            >
              <Item
                locateInMenu="never"
                location="center"
                widget="dxButton"
                options={submitButtonOptions}
              />
            </Toolbar>
            <div>
              <form
                id="frm"
                className={
                  "class='content-block dx-card form responsive-paddings'"
                }
                ref={this.formElement}
              >
                <TabPanel
                  deferRendering={false}
                  selectedIndex={this.state.selectedTabIndex}
                  animationEnabled={true}
                  swipeEnabled={true}
                  onSelectionChanged={onTabSelectionChanged}
                >
                  {this.template.tabs.map((field) => this.createTabs(field))}
                </TabPanel>
                <Button
                  horizontalAlignment="right"
                  text={" הקודם "}
                  icon={"arrowright"}
                  type="success"
                  onClick={this.PrevTab}
                />
                <Button
                  horizontalAlignment="left"
                  text="הבא"
                  icon={"arrowleft"}
                  rtlEnabled={true}
                  type="success"
                  visible={this.state.isNextTabVisible}
                  style={{
                    float: "left",
                  }}
                  onClick={this.NextTab}
                />
              </form>
              <Footer>
                Copyright © 2010-{new Date().getFullYear()}{" "}
                {appInfo.companyEnglishName}.{/* <br /> */}
                כל הזכויות שמורות.
              </Footer>
            </div>
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div>
            <h1>מייד עולים 😎</h1>
          </div>
          <div>
            <LoadIndicator id="large-indicator" height={60} width={60} />
          </div>
        </React.Fragment>
      );
    }
  }

  createTabs(field) {
    let par = field.Value.split("|");
    if (field.Type === "single") {
      return this.getSimpleTabItems(field.caption, par[0], par[1]);
    } else if (field.Type === "array") {
      return this.getArrayTabItems(
        field.caption,
        par[0],
        par[1],
        par[2],
        field
      );
    }
  }

  flatObject(obj) {
    const rtn = {};
    obj.account.map((item, i) =>
      Object.keys(item).map(
        (key) => (rtn["account[" + i + "]." + key] = item[key])
      )
    );
    obj.owner.map((item, i) =>
      Object.keys(item).map(
        (key) => (rtn["owner[" + i + "]." + key] = item[key])
      )
    );
    Object.keys(obj.NeadAnalysis).map(
      (key) => (rtn["NeadAnalysis." + key] = obj.NeadAnalysis[key])
    );
    Object.keys(obj.Policy).map(
      (key) => (rtn["Policy." + key] = obj.Policy[key])
    );
    Object.keys(obj.apendix).map(
      (key) => (rtn["apendix." + key] = obj.apendix[key])
    );
    //  Object.keys(obj.agreement).map((key) => rtn["agreement." + key] = obj.agreement[key]);
    Object.keys(obj.files).map((key) => (rtn["files." + key] = obj.files[key]));

    return rtn;
  }

  fetchTemplate = () => {
    const apiPath = window.location.hash.substring(17).slice(0, -15);
    const url = `https://script.google.com/macros/s/${apiPath}`;
    //create group by objects name
    function groupBy3(xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    }

    //get date from Spreadsheet
    if (this.state.isFirsTimeLoaded) {
    } else {
      fetch(url)
        .then((response) => response.json())
        .then((values) => {
          //   const data = groupBy3(addKey(values.values), 'object')
          const data = groupBy3(values, "object");
          this.template = data;
          this.setState({ isFirsTimeLoaded: true });
          this.setState({ logoUrl: data.logo[0].Value }); //set company logo to state
        });
    }
  };

  getItemArray(obj) {
    let dataItems = obj.split("|");
    dataItems = dataItems.map((item) => item.split(":"));
    const values = [];
    dataItems.forEach((element) => {
      values.push({
        id: element[0],
        name: element[1],
      });
    });
    return values;
  }

  getTabs = (field, fields, key, values, thisObj, index, title, header) => {
    return (
      <Tab
        title={title + " " + (parseInt(index) + 1)}
        colCount={2}
        key={"tab" + key}
      >
        <TabPanelOptions colCount={1} deferRendering={false} />
        {fields.map(function (item) {
          return thisObj.getField(item, key + item._uid, index, title);
        })}
        <ButtonItem
          horizontalAlignment="left"
          colSpan={2}
          style={{
            backgroundColor: "red",
          }}
          buttonOptions={{
            text: "הסר " + title + "✖️",
            type: "danger",
            disabled: values[header].length === 1,
            onClick: (e) => this.deleteOwner(e, index, fields),
          }}
        />
      </Tab>
    );
  };

  getArrayTabItems(title, keyHeader, iconName, addButtonTitle, field) {
    return (
      <Item title={title} badge={this.doc[keyHeader].length} icon={iconName}>
        <Form
          className={"class='content-block dx-card responsive-paddings'"}
          showValidationSummary={false}
          method="post"
          action={REACT_APP_SERVER_URL + "docfile1"}
          colCount={1}
          id="form"
          formData={this.doc}
          validationGroup="ownerGroup"
        >
          <ButtonItem
            horizontalAlignment="right"
            buttonOptions={{
              text: addButtonTitle,
              type: "success",
              onClick: (e) => {
                this.doc[keyHeader].push({});
                this.updatePhones();
              },
              disabled: this.doc[keyHeader].length >= field.maxValue,
            }}
          />
          <TabbedItem colCount={2} key={"tabAlltabGroup"}>
            <TabPanelOptions deferRendering={false} swipeEnabled={false} />
            <ColCountByScreen xs={1} sm={2} md={3} />
            {this.doc[keyHeader].map((item, i) =>
              this.getTabs(
                item,
                this.template[keyHeader],
                keyHeader + "[" + i + "].",
                this.doc,
                this,
                i,
                title,
                keyHeader
              )
            )}
          </TabbedItem>
        </Form>
      </Item>
    );
  }

  getSimpleTabItems(title, keyHeader, iconName) {
    return (
      <Item title={title} icon={iconName}>
        <Form
          className={"class='content-block dx-card responsive-paddings'"}
          showValidationSummary={false}
          method="post"
          action={REACT_APP_SERVER_URL + "docfile1"}
          colCount={1}
          id="form"
          formData={this.doc}
          validationGroup="ownerGroup"
        >
          {this.template[keyHeader].map((field) =>
            this.getField(field, keyHeader + "." + field._uid, "", title)
          )}
        </Form>
        {/* { <ValidationSummary id="summary" validationGroup="ownerGroup"></ValidationSummary> } */}
      </Item>
    );
  }

  getField = (dataForField, key, index, title) => {
    const fieldVisible = dataForField.visible
      ? this.visibleFunction(
          dataForField.visible.replaceAll("[x]", "[" + index + "]")
        )
      : this.visibleFunction(dataForField.visible);
    var opt = {
      dataField: { key },
      key: { key },
      rtlEnabled: true,
      items: dataForField.Value.split("|"),
      //defaultValue: dataForField.NOTE,
      // defaultValue: dataForField.Value.split("|")[0],

      format: dataForField.mask,
      // defaultValue: 0.012, -->not working

      // mask: "",
      // maskRules: {x: /^[a-z\u0590-\u05fe]+$/i} ,
      // maskRules: {x: /[a-z]/} ,

      max: dataForField.maxValue,
      min: dataForField.minValue,

      onValueChanged: (e) => {
        this.execFunction(dataForField.onChangeValue, e);
        // eval(dataForField.onChangeValue);
        this.updatePhones();
      },
      visible: fieldVisible,
      multiline: true,
      // validationRules: this.getValidation(dataForField, title),
    };

    if (dataForField._uid) {
      switch (dataForField.Type) {
        case "TextStat":
          return (
            <GroupItem
              key={key}
              colSpan={dataForField.colSpan}
              cssClass={dataForField._uid}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: fieldVisible
                    ? dataForField.caption.replaceAll("\n", "<br>")
                    : "",
                }}
                id={dataForField._uid}
                // onMouseEnter={this.toggleDefault}
                // onMouseLeave={this.toggleDefault}
              />
            </GroupItem>
          );
        case "Header":
          return (
            <GroupItem key={key} colSpan={4} caption={dataForField.helpText}>
              <h3>{dataForField.caption}</h3>
            </GroupItem>
          );
        case "Header2":
          return (
            <GroupItem key={key} colSpan={4} caption={dataForField.helpText}>
              <h4>{dataForField.caption}</h4>
            </GroupItem>
          );
        case "Label":
          return (
            <GroupItem key={key} colSpan={4}>
              <h5>{dataForField.caption}</h5>
            </GroupItem>
          );

        case "img":
          const imgOpt = {
            visible: { fieldVisible },
            uploadMode: "useForm",
            minFileSize: 1024,
            selectButtonText: dataForField.caption,
            labelText: dataForField.helpText,
            accept: "image/*",
            readyToUploadMessage: "Ready to upload",
          };
          return (
            <GroupItem key={key} colSpan={4}>
              <SimpleItem
                editorType="dxFileUploader"
                editorOptions={imgOpt}
                colSpan={dataForField.colSpan}
                dataField={"fileUploader" + key}
                key={"fileUploader" + key}
                helpText={dataForField.helpText}
                visible={fieldVisible}
                // validationRules={this.getValidation(dataForField, title)}
                showValidationSummary={true}
              >
                <Label text={dataForField.caption} />
              </SimpleItem>
            </GroupItem>
          );

        case "dxRadioGroup":
          //   opt = opt.push({items:data.Value.split("|")})

          return (
            <GroupItem key={"grp" + key} colSpan={dataForField.colSpan}>
              <SimpleItem
                editorType="dxRadioGroup"
                editorOptions={opt}
                colSpan={dataForField.colSpan}
                dataField={key}
                key={key}
                helpText={dataForField.helpText}
                visible={fieldVisible}
                //validationRules={this.getValidation(dataForField, title)}
                showValidationSummary={true}
              >
                <Label text={dataForField.caption} />
              </SimpleItem>
            </GroupItem>
          );

        case "dxDateBox":
          let opdb = {
            rtlEnabled: false,
            dateSerializationFormat: "yyyy-MM-dd",

            displayFormat: "dd-MM-yyyy",
            useMaskBehavior: true,
            max: dataForField.maxValue,
            min: dataForField.minValue,
            dateOutOfRangeMessage: dataForField.validationMessage,
            pickerType: "rollers",
            type: "date",
            disabled: this.visibleFunction(dataForField.disabledByRep),
            dropDownOptions: {
              height: 320,
            },
            onValueChanged: (e) => {
              this.execFunction(dataForField.onChangeValue, e);
              // eval(dataForField.onChangeValue);
              this.updatePhones();
            },
          };

          return (
            <GroupItem key={"grp" + key} colSpan={dataForField.colSpan}>
              <SimpleItem
                editorType="dxDateBox"
                editorOptions={opdb}
                helpText={dataForField.helpText}
                dataField={key}
                key={key}
                visible={fieldVisible}
                // validationRules={this.getValidation(dataForField, title)}
                showValidationSummary={true}
              >
                <Label text={dataForField.caption} />
              </SimpleItem>
            </GroupItem>
          );
        case "dxSlider":
          var par = dataForField.Value.split("|");
          var oprng = {
            //   rtlEnabled: false,
            min: parseInt(par[0]),
            max: parseInt(par[1]),
            step: parseInt(par[2]),
            visible: true,
            defaultValue: parseInt(par[1]),
            tooltip: {
              enabled: true,
              showMode: "always",
              position: "top",
              format: par[3],
            },
            lable: {
              format: par[3],
              position: "bottom",
              visible: true,
            },
            // onValueChanged: (e) => {
            //    console.log(e.value);
            //   this.updatePhones();
            // },
          };

          return (
            <GroupItem key={"grp" + key} colSpan={dataForField.colSpan}>
              <SimpleItem
                editorType="dxSlider"
                editorOptions={oprng}
                //  helpText={dataForField.helpText}
                dataField={key}
                key={key}
                visible={fieldVisible}
                //  validationRules={this.getValidation(dataForField, title)}
                showValidationSummary={true}
              >
                <Label text={dataForField.caption} />
              </SimpleItem>
            </GroupItem>
          );

        case "dxCheckBox":
          let opCb = {
            text: dataForField.caption,
            onValueChanged: (e) => {
              this.execFunction(dataForField.onChangeValue, e);
              // eval(dataForField.onChangeValue);
              this.updatePhones();
            },
          };

          return (
            <GroupItem key={"grp" + key} colSpan={dataForField.colSpan}>
              <SimpleItem
                editorType="dxCheckBox"
                editorOptions={opCb}
                helpText={dataForField.helpText}
                dataField={key}
                key={key}
                visible={fieldVisible}
                //  validationRules={this.getValidation(dataForField, title)}
                showValidationSummary={true}
              >
                <Label text={dataForField.caption} visible={false} />
              </SimpleItem>
            </GroupItem>
          );

        case "SelectBoxMulti":
          let op = {
            visible: fieldVisible,
            // height: 35,
            items: dataForField.Value.split("|"),
            onClick: () => {
              this.updatePhones();
            },
            onValueChanged: (e) => {
              this.execFunction(dataForField.onChangeValue, e);
              // eval(dataForField.onChangeValue);
              this.updatePhones();
            },
          };
          return (
            <GroupItem key={"grp" + key} colSpan={dataForField.colSpan}>
              <SimpleItem
                editorType="dxTagBox"
                colSpan={dataForField.colSpan}
                editorOptions={op}
                dataField={key}
                key={key}
                helpText={dataForField.helpText}
                // validationRules={this.getValidation(dataForField, title)}
                showValidationSummary={true}
              >
                <Label text={dataForField.caption} />
              </SimpleItem>
            </GroupItem>
          );

        case "CustomRadioBoxGroup":
          // const values = this.getItemArray(dataForField.Value);
          let op1 = {
            items: this.getItemArray(dataForField.Value),
            noDataText: "No data to display",
            displayExpr: "name",
            valueExpr: "id",

            onClick: () => {
              this.updatePhones();
            },
            onValueChanged: (e) => {
              this.execFunction(dataForField.onChangeValue, e);
              //eval(dataForField.onChangeValue);
              this.updatePhones();
            },
          };
          return (
            <GroupItem key={"grp" + key} colSpan={dataForField.colSpan}>
              <SimpleItem
                editorType="dxRadioGroup"
                colSpan={dataForField.colSpan}
                visible={fieldVisible}
                editorOptions={op1}
                dataField={key}
                key={key}
                helpText={dataForField.helpText}
                //  validationRules={this.getValidation(dataForField, title)}
                showValidationSummary={true}
              >
                <Label text={dataForField.caption} />
              </SimpleItem>
            </GroupItem>
          );

        case "CustomSelectBox":
          let dataItems = dataForField.Value.split("|");
          dataItems = dataItems.map((item) => item.split(":"));
          const values = [];
          dataItems.forEach((element) => {
            values.push({
              id: element[0],
              name: element[1],
            });
          });
          let op2 = {
            visible: true,
            items: values,
            noDataText: "No data to display",
            displayExpr: "name",
            valueExpr: "id",
            onClick: () => {
              this.updatePhones();
            },
            onValueChanged: (e) => {
              this.execFunction(dataForField.onChangeValue, e);
              // console.log(e.value);
              // eval(dataForField.onChangeValue);
              this.updatePhones();
            },
          };
          return (
            <GroupItem key={"grp" + key} colSpan={dataForField.colSpan}>
              <SimpleItem
                editorType="dxTagBox"
                colSpan={dataForField.colSpan}
                editorOptions={op2}
                dataField={key}
                key={key}
                helpText={dataForField.helpText}
                //validationRules={this.getValidation(dataForField, title)}
                showValidationSummary={true}
              >
                <Label text={dataForField.caption} />
              </SimpleItem>
            </GroupItem>
          );

        case "SelecBox":
          const sbOp = {
            visible: fieldVisible,
            items: dataForField.Value.split("|"),
            onClick: () => {
              this.updatePhones();
            },
            onValueChanged: (e) => {
              this.execFunction(dataForField.onChangeValue, e);
              //  eval(dataForField.onChangeValue);
              this.updatePhones();
            },
          };
          return (
            <GroupItem key={"grp" + key} colSpan={dataForField.colSpan}>
              <SimpleItem
                editorType="dxSelectBox"
                colSpan={dataForField.colSpan}
                editorOptions={sbOp}
                dataField={key}
                key={key}
                helpText={dataForField.helpText}
                // validationRules={this.getValidation(dataForField, title)}
                showValidationSummary={true}
              >
                <Label text={dataForField.caption} />
              </SimpleItem>
            </GroupItem>
          );

        case "dxTextArea":
          let opTa = {
            autoResizeEnabled: true,
            minHeight: 20,
            stylingMode: "outlined",
          };
          return (
            <GroupItem
              key={"grp" + key}
              colSpan={dataForField.colSpan}
              rtlEnabled={false}
            >
              <SimpleItem
                editorType={"dxTextArea"}
                colSpan={dataForField.colSpan}
                visible={fieldVisible}
                helpText={dataForField.helpText}
                editorOptions={opTa}
                rtlEnabled={false}
                //validationRules={this.getValidation(dataForField, title)}
                dataField={key}
                key={key}
              >
                <Label text={dataForField.caption} />
              </SimpleItem>
            </GroupItem>
          );

        case "phone":
          let opPhone = {
            visible: true,
            rtlEnabled: false,
            elementAttr: { class: "phone" },
            //  mask: '(X00) 00-0000000',
            //  maskRules: { 'X': /[01-9]/ },
            mask: this.state.phoneMask,
            // maskRules: {'X': /[0-9]/, '7':/[0-9]/},
            useMaskedValue: true,
            //placeholder: "972-5X-XXXXXXX",
            onClick: () => {
              this.updatePhones();
            },
            onValueChanged: (e) => {
              this.execFunction(dataForField.onChangeValue, e);
              //eval(dataForField.onChangeValue);
              this.updatePhones();
            },
          };

          return (
            <GroupItem
              key={"grp" + key}
              colSpan={dataForField.colSpan}
              rtlEnabled={false}
            >
              <SimpleItem
                editorType={"dxTextBox"}
                colSpan={dataForField.colSpan}
                visible={fieldVisible}
                helpText={dataForField.helpText}
                validationRules={this.getValidation(dataForField, title)}
                editorOptions={opPhone}
                rtlEnabled={false}
                dataField={key}
                key={key}
              >
                <Label text={dataForField.caption} />
              </SimpleItem>
            </GroupItem>
          );

        default:
          return (
            <GroupItem key={"grp" + key} colSpan={dataForField.colSpan}>
              <SimpleItem
                editorType={dataForField.Type}
                colSpan={dataForField.colSpan}
                visible={fieldVisible}
                editorOptions={opt}
                helpText={dataForField.helpText}
                //validationRules={this.getValidation(dataForField, title)}
                dataField={key}
                key={key}
              >
                <Label text={dataForField.caption} />
              </SimpleItem>
              {/* <span id={dataForField._uid}
                  onMouseEnter={this.toggleDefault}
                  onMouseLeave={this.toggleDefault}>
                </span> */}
            </GroupItem>
          );
      }
    } else {
      return (
        <GroupItem
          caption={dataForField.caption}
          key={"rwsr" + Math.floor(Math.random() * 20000)}
        >
          <p>{dataForField.caption}</p>
        </GroupItem>
      );
    }
  };
  //GENEREATS THE VALIDATION ARRAY FOR THE GETFIELD FUNCTION ON RUNTIME
  getValidation = (dataField, title) => {
    let validationArray = [];
    if (dataField.validation.includes("email"))
      validationArray.push({
        type: "email",
        message: "יש להזין אי מייל תקין" + ` (${title})`,
      });

    if (dataField.validation.includes("numeric"))
      validationArray.push({
        type: "numeric",
        message: "יש להזין מספרים בלבד" + ` (${title})`,
      });

    if (dataField.validation.includes("range"))
      validationArray.push({
        type: "range",
        message: "חובה למלא שדה " + dataField.caption + ` (${title})`,
      });

    // if (dataField.validation.includes("stringLength"))
    //   validationArray.push({
    //     type: "stringLength",
    //     message: "חובה למלא שדה " + dataField.caption + ` (${title})`,
    //   });

    if (dataField.validation.includes("phone"))
      validationArray.push({
        type: "custom",
        validationCallback: this.ValidatePhones,
        message:
          "אין לעשות שימוש חוזר במספר טלפון שכבר הוקלד בטופס" + ` (${title})`,
      });

    if (dataField.validation.includes("id"))
      validationArray.push({
        type: "custom",
        validationCallback: this.ValidateID,
        message: " יש להזין ת.ז תקין" + ` (${title})`,
      });

    if (dataField.validation.includes("compare"))
      validationArray.push({
        type: "compare",
        message: "חובה למלא שדה " + dataField.caption + ` (${title})`,
      });

    if (dataField.validation.includes("pattern"))
      validationArray.push({
        type: "pattern",
        pattern: dataField.validationPatameters,
        message: dataField.validationMessage + ` (${title})`,
      });

    if (dataField.validation.includes("img"))
      validationArray.push({
        type: "required",
        message: dataField.validationMessage + ` (${title})`,
      });

    // if (this.visibleFunction(dataField.required))
    //   validationArray.push({
    //     type: "required",
    //     message: "חובה למלא שדה " + dataField.caption + ` (${title})`,
    //   });

    return validationArray;
  };

  HideNextTab() {
    if (this.state.selectedTabIndex === 5) {
      this.setState({ isNextTabVisible: false });
    } else {
      this.setState({ isNextTabVisible: true });
    }
  }

  NextTab() {
    const top = document.getElementById("top");
    top.scrollIntoView();
    this.setState({
      selectedTabIndex: this.state.selectedTabIndex + 1,
    });
    this.HideNextTab();
  }

  PrevTab() {
    this.HideNextTab();
    const top = document.getElementById("top");
    top.scrollIntoView();
    this.setState({
      selectedTabIndex: this.state.selectedTabIndex - 1,
    });
  }

  updatePhones() {
    this.setState({
      refreshCounter: this.state.refreshCounter + 1,
    });
  }

  visibleFunction(obj, i) {
    try {
      let ans = eval(obj);
      if (ans === false) {
        return false;
      } else {
        return true;
      }
    } catch {
      return false;
    }
  }

  execFunction(obj, i) {
    try {
      let ans = eval(obj);
    } catch {
      return false;
    }
  }
  sendForm(e) {
    var form = this.formElement.current; //retrieve the form as a DOM element
    var sendInput = {
      flatValues: this.flatObject(this.doc),
      document: this.doc,
      // formId: this.state.dataFromDB.form.listOfForms[0].ID,
      // template: this.template,
    };
    var input = document.createElement("input"); //prepare a new input DOM element
    input.setAttribute("name", "jsonValues"); //set the param name
    input.setAttribute("value", JSON.stringify(sendInput)); //set the value
    input.setAttribute("type", "hidden"); //set the type, like "hidden" or other

    form.appendChild(input);
    const data = new FormData(form);
    this.setState({ isFirsTimeLoaded: false });
    this.PostFormToDB(data);
  }

  async PostFormToDB(data) {
    const agentPhone = window.location.hash.slice(-15);
    const response = await fetch(
      `${REACT_APP_SERVER_URL}ClientFile?${agentPhone}`,
      {
        method: "POST",
        body: data,
        credentials: "include",
      }
    );
    if (response.ok) {
      notify("הטופס נשלח לבעל הרשיון בהצלחה", "success", 3000);
      this.setState({ isFirsTimeLoaded: false, isFormSubmited: true });
    } else {
      notify("משהו השתבש .. נסה שנית", "error", 3000);
      // throw new Error("משהו השתבש .. נסה שנית")
    }
  }
}

export default App;
